var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleCheckIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.999 5.33301C46.7057 5.33301 58.666 17.2933 58.666 32C58.666 46.7067 46.7057 58.667 31.999 58.667C17.2924 58.667 5.33203 46.7067 5.33203 32C5.33203 17.2933 17.2924 5.33301 31.999 5.33301ZM31.999 8C18.7724 8 7.99902 18.7733 7.99902 32C7.99902 45.2267 18.7724 56 31.999 56C45.2257 56 55.999 45.2267 55.999 32C55.999 18.7733 45.2257 8 31.999 8ZM49.4795 21.6133L25.8652 45.2139L14.5195 33.8672L16.3994 31.9736L25.8652 41.4531L47.5986 19.7197L49.4795 21.6133Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleCheckIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Circle_Check_Icon.a4d4cacb372bf0139232715011d7cc5d.svg";